"use client";

import { useTranslations } from "next-intl";
import { SectionLayout } from "@/components/layout/SectionLayout";
import { PrimaryButton } from "@/components/buttons/PrimaryButton";
import { motion } from "framer-motion";

export const CTASection = () => {
  const t = useTranslations("cta");

  // Variants pour les animations
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const buttonVariants = {
    hidden: {
      opacity: 0,
      scale: 0.9,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <SectionLayout id="contact">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, margin: "-100px" }}
        className="flex w-full flex-col items-center justify-center gap-8 rounded-xl bg-secondary p-48 text-center"
      >
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
          className="flex flex-col gap-24"
        >
          <motion.p
            variants={itemVariants}
            className="font-sentient text-2xl font-medium text-primary sm:text-3xl md:text-4xl lg:text-5xl"
          >
            {t("title")}
          </motion.p>
          <motion.p variants={itemVariants} className="text-accent">
            {t("subtitle")}
          </motion.p>
        </motion.div>

        <motion.div
          variants={buttonVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          <PrimaryButton
            text={t("button")}
            variant="bordered"
            navigateTo="https://calendly.com/agence-virtuosa/appel-decouverte"
            target="_blank"
          />
        </motion.div>

        <motion.div
          variants={itemVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          <p className="text-accent">
            {t("contact.text")}{" "}
            <a href={`mailto:${t("contact.email")}`} className="text-primary">
              {t("contact.email")}
            </a>
          </p>
        </motion.div>
      </motion.div>
    </SectionLayout>
  );
};
